/** Time-of-day greeting for the empty state. Without a name there is nothing
 *  personal to say, so it falls back to a neutral hello. */
export function greetingFor(date: Date, name?: string): string {
  const first = name?.trim().split(/\s+/)[0];
  if (!first) return 'Hi there';

  const hour = date.getHours();
  let part = 'Good evening';
  if (hour >= 5 && hour < 12) {
    part = 'Good morning';
  } else if (hour >= 12 && hour < 17) {
    part = 'Good afternoon';
  }
  return `${part}, ${first}`;
}
